export const getCurrentDomain = ".ehorus.com.br";
